import React from 'react'
import { Button } from '@frontend/pole-ui/lib/components/Button'
import { messages } from '@/components/composed/pwa/Notification/components/messages'
import type { IPlatformProps } from '../types'
import '../styles.scss'

export const Android = (props: IPlatformProps) => {
  const { onActionButtonClick } = props

  return (
    <>
      <h3 className={'notification__header'}>{messages.android.header}</h3>
      <p className={'notification__text'}>{messages.android.text}</p>
      <Button modifiers={['green', 'full-width-always']} onClick={onActionButtonClick} className={'notification__actionButton'}>
        {messages.android.buttonLabel}
      </Button>
    </>
  )
}
